require('./warrantsBuySellSummary.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const {
    BROKER_BUY_FOR_APPROX_IMPORT,
    CHARGE_ACCOUNT_PREFIX
} = require('constants/index');
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

// @components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

class WarrantsBuySellSummary extends React.Component {

    constructor(props) {
        super(props);
    }

    buildValidityDateBlock(uppercaseTitle) {
        const { step1 } = this.props;
        const formattedValidityDate = step1.get('validityDate').format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));

        return (
            <OKInformativeListItem
                title={formatText('broker-stocksBuySellSummaryVilidityTermTitle')}
                bodyText={formattedValidityDate}
                isUppercaseTitle={uppercaseTitle}
            />
        );
    }

    amountOfTitlesOrApproxImport(buyFor, step2, uppercaseTitle) {
        if (buyFor === BROKER_BUY_FOR_APPROX_IMPORT) {
            return (
                <OKInformativeListItem
                    title={formatText('broker-warrantsAdvancedBuyApproxImportSummaryLabel')}
                    bodyText={step2.get('buyForApproxImport').toString() + " EUR"}
                    isUppercaseTitle={uppercaseTitle}
                />
            );
        } else {
            return (
                <OKInformativeListItem
                    title={formatText('broker-stocksBuySellSummaryTitlesQuantityTitle')}
                    bodyText={step2.get('titleQuantity').toString()}
                    isUppercaseTitle={uppercaseTitle}
                />
            );
        }
    }

    render() {
        const { stockContract, warrantFile, step2, columns, isSell } = this.props;

        const limitPrice = step2.get('limitPrice').toString();
        const underlying = warrantFile.getIn(['warrant', 'underlyingName']);
        const companyName = warrantFile.get('companyName') || '-';
        const buyFor = step2.get('buyFor');

        const uppercaseTitle = true;
        const warrantToBuyTitle = isSell ?
            formatText('broker-warrantsAdvancedSellSummaryOperationTitle') :
            formatText('broker-warrantsAdvancedBuySummaryOperationTitle');
        const warrantLimitPriceTitle = formatText('broker-warrantSummaryLimitPriceTitle');
        const warrantUnderlyingTitle = formatText('broker-warrantsUnderlyingName');

        const amountOrImportBlock = this.amountOfTitlesOrApproxImport(buyFor, step2, uppercaseTitle);

        return (
            <section className="warrants-buy-sell-summary__info-section row">
                <div className={`col-lg-${columns}`}>
                    <div className="warrants-buy-sell-summary__titles-container-left">
                        <OKInformativeList>
                            <OKInformativeListItem
                                title={warrantToBuyTitle}
                                bodyText={companyName}
                                columns={1}
                                isUppercaseTitle={uppercaseTitle}
                            />
                            <OKInformativeListItem
                                title={formatText('broker-stocksBuySellSummaryStockContractTitle')}
                                bodyText={stockContract.get('walletAccountType') + ' ' + stockContract.get('walletTitular')}
                                columns={1}
                                isUppercaseTitle={uppercaseTitle}
                            >
                                <span className="warrants-buy-sell-summary__stock-container-info warrants-buy-step2__stock-container-info--account">
                                    {CHARGE_ACCOUNT_PREFIX}{stockContract.get('controlDigit')}{stockContract.get('productNumber')}{stockContract.get('walletNumber')}
                                </span>
                                <FormattedText
                                    value="broker-stocksBuySellSummaryFirstTitularText"
                                    injectedStrings={[stockContract.get('firstTitular')]}
                                    className="warrants-buy-sell-summary__stock-container-info"
                                />
                                <FormattedText
                                    value="broker-stocksBuySellSummaryAssociatedAccountText"
                                    injectedStrings={[stockContract.get('associatedAccountAlias')]}
                                    className="warrants-buy-sell-summary__stock-container-info"
                                />
                                <span className="warrants-buy-sell-summary__stock-container-info">
                                    {stockContract.get('associatedAccount')}
                                </span>
                            </OKInformativeListItem>
                        </OKInformativeList>
                    </div>
                </div>

                <div className={`col-lg-${columns}`}>
                    <div className="warrants-buy-sell-summary__titles-container-right">
                        <OKInformativeList>

                            {amountOrImportBlock}

                            <OKInformativeListItem
                                title={warrantLimitPriceTitle}
                                bodyText={limitPrice}
                                isUppercaseTitle={uppercaseTitle}
                            />
                            <OKInformativeListItem
                                title={warrantUnderlyingTitle}
                                bodyText={underlying}
                                isUppercaseTitle={uppercaseTitle}
                            />

                        </OKInformativeList>
                    </div>
                </div>
            </section>
        );
    }
}

WarrantsBuySellSummary.propTypes = {
    warrantFile: PropTypes.object.isRequired,
    stockContract: PropTypes.object.isRequired,
    step1: PropTypes.object.isRequired,
    step2: PropTypes.object,
    columns: PropTypes.number.isRequired,
    isSell: PropTypes.bool
};

WarrantsBuySellSummary.defaultProps = {
    columns: 5
};

module.exports = WarrantsBuySellSummary;
